/**
 * Celsius <-> Fahrenheit helpers for the Maturity Target forms.
 * Values are held as strings in form state (allowing an empty/partial input);
 * conversion returns a string rounded to 1 decimal, or '' for blank/invalid.
 */

const roundStr = (n: number): string => {
  if (!Number.isFinite(n)) return '';
  return String(Math.round(n * 10) / 10);
};

export const cToF = (celsius: string): string => {
  const c = parseFloat(celsius);
  if (celsius.trim() === '' || Number.isNaN(c)) return '';
  return roundStr(c * 1.8 + 32);
};

export const fToC = (fahrenheit: string): string => {
  const f = parseFloat(fahrenheit);
  if (fahrenheit.trim() === '' || Number.isNaN(f)) return '';
  return roundStr((f - 32) / 1.8);
};

/** Q = ActivationEnergy / 8.31, rounded to the nearest integer (display only). */
export const activationEnergyToQ = (activationEnergy: string): string => {
  const ae = parseFloat(activationEnergy);
  if (activationEnergy.trim() === '' || Number.isNaN(ae)) return '';
  return String(Math.round(ae / 8.31));
};

/** Inverse of activationEnergyToQ: AE = Q * 8.31, rounded to nearest integer. */
export const qToActivationEnergy = (q: string): string => {
  const qv = parseFloat(q);
  if (q.trim() === '' || Number.isNaN(qv)) return '';
  return String(Math.round(qv * 8.31));
};
